import { render } from "./ListPackage.vue?vue&type=template&id=5e3c21d6&scoped=true&ts=true"
import script from "./ListPackage.vue?vue&type=script&lang=ts"
export * from "./ListPackage.vue?vue&type=script&lang=ts"

import "./ListPackage.vue?vue&type=style&index=0&id=5e3c21d6&scoped=true&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e3c21d6"]])

export default __exports__